import { Trans } from '@lingui/react'
import { IconCaretRight } from '@redteclab/icons'
import classnames from 'clsx'
import type { FC } from 'react'

import { type RedirectData } from 'shared/experiments/components/AfterQuerySuggestLayer/index'
import LinkWithIcon from 'views/components/molecules/LinkWithIcon'

const RedirectsList: FC<{
  redirectData: RedirectData
  shopUrl: string
  lpRedirect?: boolean
}> = ({ redirectData, shopUrl, lpRedirect = true }) => {
  return (
    <>
      {redirectData.map(redirect => (
        <li
          key={redirect.suggestText}
          className={classnames(
            'o-SearchBox__search-suggest u-padding-xx-small--bottom',
            {
              'o-SearchBox__search-suggest-lp-redirect': lpRedirect,
              'o-SearchBox__search-suggest-category-redirect': !lpRedirect,
            }
          )}
        >
          {lpRedirect ? (
            <div>
              <span className="o-SearchBox__search-suggest__redirect-heading">
                <Trans id="general.label.goToInfoPage" />
              </span>
              <LinkWithIcon
                href={shopUrl + '/' + redirect.redirectTarget}
                icon={<IconCaretRight />}
                right
              >
                {redirect.suggestText}
              </LinkWithIcon>
            </div>
          ) : (
            <a
              className="o-SearchBox__search-suggest__category-suggestion"
              href={shopUrl + '/' + redirect.redirectTarget}
            >
              {redirect.suggestText}
            </a>
          )}
        </li>
      ))}
    </>
  )
}

export default RedirectsList
